import { Modal } from '@app/components/modals';
import { ProductionCapacityEditor } from './ProductionCapacityEditor';

export default function CapacityModal({
  index,
  onClose
}: {
  index: number;
  onClose: () => void;
}) {
  return (
    <Modal isOpen={true}>
      <ProductionCapacityEditor index={index} onClose={onClose} />
    </Modal>
  );
}
